export default __webpack_public_path__ + "static/media/vkpic10.b61d0e4e.png";